const resourceEndpoint = (process.env.APP_NODE_ENV || process.env.NODE_ENV) === 'production'
  ? 'https://www.straitstimes.com/multimedia/graphics/json/'
  : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

export default {
  install (Vue) {
    const getEventsData = function () {
      const url = resourceEndpoint + '1YLx7gds4J4a8ZHPsBpJNmOfyNdFGb08afrPGIR5Y5Mc/0.json'
      fetch(url)
      .then(res => res.json())
      .then((jsonkeydata) => {
        if (!jsonkeydata) return

        var constituencies = {}
        var parties = {}
        var candidates = {}
        var variableData = {
          numhappeningnowctr: 0,
          numtodayctr: 0,
          numtomorrowctr: 0
        }
        jsonkeydata.forEach((element, i) => {
          const now = new Date()
          var start = new Date(element.start)
          var end = new Date(element.end)
          element.index = i
          if (start <= now && end && end >= now) {
            element['noun'] = 'happening now'
            element['daystring'] = 'happening now'
            variableData.numhappeningnowctr++
            variableData.numtodayctr++
          } else {
            if (now.toLocaleDateString() === start.toLocaleDateString()) {
              element['noun'] = 'today'
              element['daystring'] = 'today, ' + start.toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'}) + (end < now ? ' (Over)' : '')
              variableData.numtodayctr++
            } else {
              start.setDate(start.getDate() - 1)
              if (now.toLocaleDateString() === start.toLocaleDateString()) {
                element['noun'] = 'tomorrow'
                element['daystring'] = 'tomorrow, ' + start.toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'})
                variableData.numtomorrowctr++
              } else {
                element['noun'] = ''
                element['daystring'] = getDateFormat(element.start) + (end < now ? ' (Over)' : '')
              }
            }
          }

          // get constituency
          if (element.constituency) {
            var valArr = element.constituency.split(',')
            valArr.forEach((consti) => {
              var constituencyKey = consti.trim().toLowerCase()
              if (constituencies[constituencyKey]) {
                constituencies[constituencyKey].push(i)
              } else {
                constituencies[constituencyKey] = [i]
                constituencies[constituencyKey].name = consti.trim()
              }
            })
          } else {
            // put it on default for all constituency
            if (constituencies.default) {
              constituencies.default.push(i)
            } else {
              constituencies.default = [i]
              constituencies.default.name = element.constituency
            }
          }

          // get parties
          if (element.party) {
            var partyKey = element.party.toLowerCase()
            if (parties[partyKey]) {
              parties[partyKey].push(i)
            } else {
              parties[partyKey] = [i]
              parties[partyKey].name = element.party
            }
          }

          // get parties
          if (element['list-names']) {
            var candidateArr = element['list-names'].split(';')
            candidateArr.forEach((candname) => {
              var candidateKey = candname.trim().toLowerCase()
              if (candidates[candidateKey]) {
                candidates[candidateKey].push(i)
              } else {
                candidates[candidateKey] = [i]
                candidates[candidateKey].name = candname.trim()
              }
            })
          }
        })

        variableData.numhappeningnow = numWordAuto(variableData.numhappeningnowctr)
        variableData.numtoday = numWordAuto(variableData.numtodayctr)
        variableData.numtomorrow = numWordAuto(variableData.numtomorrowctr)

        this.$store.commit('pushResponse', {
          eventsdata: jsonkeydata,
          variableData,
          constituencies,
          parties,
          candidates
        })
      })
      .catch(err => { throw err })
    }

    const getEventsConstituenciesData = function () {
      const url = resourceEndpoint + '1YLx7gds4J4a8ZHPsBpJNmOfyNdFGb08afrPGIR5Y5Mc/53276953.json'
      fetch(url)
      .then(res => res.json())
      .then((data) => {
        if (!data) return
        this.$store.commit('pushResponse', {
          eventsconstituencies: data
        })
      })
      .catch(err => { throw err })
    }

    const getDateFormat = function (date) {
      const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
      return (new Date(date).toLocaleString('en-us', options))
    }

    const googleDateFormat = function (val) {
      var date = new Date(val)
      return (date).toISOString().replace(/-|:|\.\d\d\d/g, '')
    }

    const numWordAuto = function (numstr) {
      if (+numstr >= 10) {
        // digits after nine
        return (+numstr).toLocaleString()
      }
      return numWord(numstr)
    }

    const numWord = function (numstr) {
      const arr = x => Array.from(x)
      const num = x => Number(x) || 0
      const isEmpty = xs => xs.length === 0
      const take = n => xs => xs.slice(0, n)
      const drop = n => xs => xs.slice(n)
      const reverse = xs => xs.slice(0).reverse()
      const comp = f => g => x => f(g(x))
      const not = x => !x
      const chunk = n => xs =>
        isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))]

      let numToWords = n => {
        let a = [
          '', 'one', 'two', 'three', 'four',
          'five', 'six', 'seven', 'eight', 'nine',
          'ten', 'eleven', 'twelve', 'thirteen', 'fourteen',
          'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
        ]

        let b = [
          '', '', 'twenty', 'thirty', 'forty',
          'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
        ]

        let g = [
          '', 'thousand', 'million', 'billion', 'trillion', 'quadrillion',
          'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion'
        ]

        // this part is really nasty still
        // might edit this again later
        let makeGroup = ([ones, tens, huns]) => {
          return [
            num(huns) === 0 ? '' : a[huns] + ' hundred ',
            num(ones) === 0 ? b[tens] : b[tens] && b[tens] + '-' || '',
            a[tens + ones] || a[ones]
          ].join('')
        }

        let thousand = (group, i) => group === '' ? group : `${group} ${g[i]}`

        if (typeof n === 'number') {
          return numToWords(String(n))
        } else if (n === '0') {
          return 'zero'
        } else {
          return (comp(chunk(3))(reverse)(arr(n))
            .map(makeGroup)
            .map(thousand)
            .filter(comp(not)(isEmpty))
            .reverse()
            .join(' '))
        }
      }
      return numToWords(numstr).trim()
    }

    const replaceVar = function (str = '', data = {}) {
      const reg = /\{\{(.*?)\}\}/
      var found = reg.exec(str)
      const storeState = this.$store.state.variableData
      while (found) {
        var varArr = found[1].split(':')
        var val = ''
        var numberKey = varArr[0].replace('empty', '')
        if (numberKey in data) {
          val = data[varArr[0]]
          if (varArr[0].includes('num') && varArr.length > 2) {
            numberKey = numberKey.replace('ctr', '').replace('word', '') + 'ctr'
            if (varArr[0].includes('empty')) {
              val = +data[numberKey] > 1 ? varArr[2] : varArr[1]
            } else {
              val += +data[numberKey] > 1 ? varArr[2] : varArr[1]
            }
          }
          str = str.replace(found[0], val)
        } else if (numberKey in storeState) {
          // if no data is provided, look in the store variableData
          val = storeState[varArr[0]]
          if (varArr[0].includes('num') && varArr.length > 2) {
            numberKey = numberKey.replace('ctr', '').replace('word', '') + 'ctr'
            if (varArr[0].includes('empty')) {
              val = +storeState[numberKey] > 1 ? varArr[2] : varArr[1]
            } else {
              val += +storeState[numberKey] > 1 ? varArr[2] : varArr[1]
            }
          }
          str = str.replace(found[0], val)
        } else {
          str = str.replace(found[0], '')
        }
        found = reg.exec(str)
      }
      return str
    }

    Vue.prototype.$replaceVar = replaceVar
    Vue.prototype.$getEventsData = getEventsData
    Vue.prototype.$getEventsConstituenciesData = getEventsConstituenciesData
    Vue.prototype.$googleDateFormat = googleDateFormat
    Vue.prototype.$numWordAuto = numWordAuto
  }
}
